import { render, staticRenderFns } from "./WaveMoneyTransactionDetail.vue?vue&type=template&id=e4cea1ba&scoped=true"
import script from "./WaveMoneyTransactionDetail.vue?vue&type=script&lang=js"
export * from "./WaveMoneyTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cea1ba",
  null
  
)

export default component.exports